module.exports = __webpack_public_path__ + "static/media/leading-mental-health.807ea3e8.png";